import { toKebabCase } from '../../../../ui/utils/toKebabCase';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const MissionDetailsPlaceholders = ({ placeHolders }) => {
    return (React.createElement(Box, { sx: { display: 'flex', gap: 2 } }, placeHolders.map((placeHolder) => (React.createElement(Box, { "data-test": `mission-place-holder-${toKebabCase(placeHolder.title)}`, key: placeHolder.title, sx: { display: 'flex', flexDirection: 'column', gap: 1, flexGrow: 1 } },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                columnGap: 1,
                color: (theme) => theme.palette.grey[500],
            } },
            placeHolder.icon,
            React.createElement(Typography, { sx: { color: (theme) => theme.palette.grey[700], lineHeight: { xs: 'unset', lg: 'inherit' } }, variant: 'overline' }, placeHolder.title)),
        React.createElement(Typography, { variant: 'h5' }, placeHolder.value))))));
};
